<template>
  <div>
    <Sticky class="move-tab-list">
      <div class="search-input-mobile">
        <Search show-action left-icon="" v-model="keyWords" :placeholder="$t('searchJob.searchPlaceholder')">
          >
          <template #left>
            <div class="search-input-left" @click="goBack">
                <img width="24" height="24" :src="left_arrow" alt="" />
            </div>
          </template>
          <template #action>
            <div class="search-input-action" @click="handleSearch">
              <img width="16" height="16" :src="search_icon" alt="" />
            </div>
          </template>
        </Search>
      </div>
      <div class="tab-search">
        <div class="tab-list">
          <div @click="
              (e) => {
                changeFilter(e, index);
              }
            " v-for="(searchItem, index) in searchList"
            :class="`filter-item ${searchItem.selectedCode?.allValue?.length ? 'over-width' : ''}`">
            <span :class="`tab-title ${activeSearch === index && 'active'}`">
              {{ searchItem.filterName }}
              <span class="filter-number" v-if="searchItem.selectedCode?.allValue?.length">
                {{ searchItem.selectedCode?.allValue?.length }}
              </span>
              <img :src="activeSearch === index ? up_arrow_b : down_arrow_b" alt="" width="8" height="8" />
            </span>
          </div>
          <div v-if="filterType === 'list'" class="search-sort" @click="changeSortType">
            <span> {{ $t("searchJob.releaseDate") }} </span>
            <img :class="`sort-icon ${sortType === 2 ? 'sort' : ''}`" width="20" height="20"
              :src="sortType === null ? sort_default_icon : sort_icon" alt="" />
          </div>
        </div>
        <div class="tab-search-right">
          <div v-show="filterType === 'location'" class="search-type" @click="changeType('list')">
            <img width="22" height="22" :src="list_icon" alt="" />
          </div>
          <div v-show="filterType === 'list'" class="search-type" @click="changeType('location')">
            <img width="22" height="22" :src="location_icon" alt="" />
          </div>
        </div>
      </div>

      <Popup :show="activeSearch !== null" position="top" @clickOverlay="activeSearch = null">
        <div class="search-input-mobile">
          <Search show-action left-icon="" v-model="keyWords" :placeholder="$t('searchJob.searchPlaceholder')">
            >
            <template #left>
              <div class="search-input-left" @click="goBack">
                <img width="24" height="24" :src="left_arrow" alt="" />
              </div>
            </template>
            <template #action>
              <div class="search-input-action" @click="handleSearch">
                <img width="16" height="16" :src="search_icon" alt="" />
              </div>
            </template>
          </Search>
        </div>
        <div class="tab-search">
          <div class="tab-list">
            <div @click="
                (e) => {
                  changeFilter(e, index);
                }
              " v-for="(searchItem, index) in searchList"
              :class="`filter-item ${activeSearch === index && 'checked'} ${searchItem.selectedCode?.allValue?.length ? 'over-width' : ''}`">
              <span :class="`tab-title ${activeSearch === index && 'active'}`">
                {{ searchItem.filterName }}
                <span class="filter-number" v-if="searchItem.selectedCode?.allValue?.length">
                  {{ searchItem.selectedCode?.allValue?.length }}
                </span>
                <img :src="activeSearch === index ? up_arrow_b : down_arrow_b" alt="" width="8" height="8" />
              </span>
            </div>
            <div v-if="filterType === 'list'" class="search-sort" @click="changeSortType">
              <span>{{ $t("searchJob.releaseDate") }} </span>
              <img :class="`sort-icon ${sortType === 2 ? 'sort' : ''}`" width="20" height="20"
                :src="sortType === null ? sort_default_icon : sort_icon" alt="" />
            </div>
          </div>
          <div class="tab-search-right">
            <div v-show="filterType === 'location'" class="search-type" @click="changeType('list')">
              <img width="22" height="22" :src="list_icon" alt="" />
            </div>
            <div v-show="filterType === 'list'" class="search-type" @click="changeType('location')">
              <img width="22" height="22" :src="location_icon" alt="" />
            </div>
          </div>
        </div>
        <MySelects v-if="activeSearch !== null" :searchItem="searchList[activeSearch]"
          @confirmSelect="confirmSelect(searchList[activeSearch])" @resetFilter="() => { resetFilter(activeSearch) }">
        </MySelects>
      </Popup>
    </Sticky>

    <jobList v-if="filterType === 'list' && jobListData.length > 0" :jobList="jobListData" :jobDetail="jobDetail"
      @getJobDetail="getJobDetail" @clearDetail="clearDetail"></jobList>
    <Loading v-show="loadingFlag && filterType === 'list'" class="loading" type="spinner" color="#000" size="40">
    </Loading>
    <NoJob v-if="filterType === 'list' && jobListData.length === 0 && !loadingFlag"></NoJob>
    <jobMap v-if="filterType === 'location'" :markers="jobListMapData" :jobDetail="jobDetail"
      @getJobDetail="getJobDetail" @clearDetail="clearDetail"></jobMap>
  </div>
</template>

<script setup>
import search_icon from "@/assets/image/searchJob/search_icon.png";
import left_arrow from "@/assets/image/searchJob/left-arrow.png";
import down_arrow_b from "@/assets/image/searchJob/down-arrow-b.png";
import up_arrow_b from "@/assets/image/searchJob/up-arrow-b.png";
import location_icon from "@/assets/image/searchJob/location-icon.png";
import list_icon from "@/assets/image/searchJob/list-icon.png";
import sort_icon from "@/assets/image/searchJob/sort-icon.png";
import sort_default_icon from '@/assets/image/searchJob/sort-default-icon.png'
import { inject, onActivated, onMounted, onUnmounted } from "vue";
import { Sticky, Popup, Search, Loading } from "vant";
import MySelects from "@/components/MySelects.vue";
import jobList from "./components/jobList.vue";
import NoJob from './components/noJob.vue'
import jobMap from "./components/jobMap2.vue";
import useJobList from './useJobList.js'
import { useRoute, useRouter } from "vue-router";
const device = inject("device");
const {
  activeSearch,
  searchList,
  jobDetail,
  loadingFlag,
  sortType,
  keyWords,
  jobListData,
  jobListMapData,
  filterType,
  previousPath,
  changeFilter,
  resetFilter,
  changeSortType,
  changeType,
  clearDetail,
  getJobDetail,
  handleSearch,
  confirmSelect, handleScroll } = useJobList()
const route = useRoute()
const router = useRouter()
keyWords.value = route.query.keyWords || ''

onActivated(() => {
  
})
onMounted(() => {
  setTimeout(() => {
    if (device.value === 'mb') {
      // 添加滚动监听
      window.addEventListener('scroll', handleScroll);
    }
  }, 200)
})
onUnmounted(() => {
  if (device.value === 'mb') {
    window.removeEventListener('scroll', handleScroll);
  }
})
const goBack = () =>{
  if(previousPath.value && previousPath.value !== '/loading'){
    router.back()
  } else {
    router.push({ path: '/home' })
  }
}

</script>

<style lang="scss" scoped>
.loading {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.move-tab-list {
  ::v-deep(.van-sticky) {
    transition: all 0.3s;
  }
}

.search-input-mobile {
  background-color: #fbf9f9;
  margin-bottom: -2px;
  padding: 0 12px;
  .van-search {
    background-color: #fbf9f9;
    padding-left: 0;
  }
  ::v-deep(.van-search__content) {
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding-top: 2px;
    padding-bottom: 2px;

    input {
      transition: all 0.3s ease;
      &:focus::placeholder {
          opacity: 0.5;
      }
    }
  }
  .search-input-left{
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 8px;
      padding-left: 0;
  }
  .search-input-action {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 28px;
    background-color: var(--hc-color--bright-purple);
    border-radius: 2px;
  }
}

.tab-search {
  padding: 6px 22px;
  display: flex;
  align-items: center;
  background-color: #fbf9f9;
  box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.3);
  font-size: 1rem;
  .tab-list {
    padding: 6px 0;
    flex: 1;
    display: flex;
    width: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .tab-title {
    color: rgba(0, 0, 0, 1);
    font-weight: 400;
    padding-right: 12px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    img {
      margin-left: 4px;
    }
    .filter-number {
      font-size: 0.75rem;
      background-color: var(--hc-color--bright-purple);
      color: var(--hc-color--white);
      width: 1rem;
      height: 1rem;
      border-radius: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;
    }
  }
  .tab-title.active {
    color: var(--hc-color--bright-purple);
  }
  .tab-search-right {
    display: flex;
  }
  .search-sort {
    color: rgba(0, 0, 0, 1);
    font-size: 1rem;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    white-space: nowrap;
         .sort-icon.sort {
           transform: rotate(180deg);
         }
  }
  .search-type {
    margin-left: 12px;
    width: 28px;
    height: 28px;
    border: 1px solid rgba(0, 47, 97, 0.2);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
